import * as React from "react";
import {
  combineHours,
  toCivilianTime,
  toDayOfWeek,
  formatHour,
} from "../helpers/time";
import { LocationHours, LocationAddress, OrderType } from "../types";

/**
 * Format location address object to a string
 */
export function formatAddress(
  { street1, city, state, zip }: LocationAddress = {
    street1: ``,
    city: ``,
    state: ``,
    zip: ``,
  },
): string {
  const streetStr = street1 ? `${street1}, ` : ``;
  const cityStr = city ? `${city}, ` : ``;

  return `${streetStr}${cityStr}${state} ${zip}`;
}

/**
 * Given an order type, return a prefix for the "____ hours" label.
 */
export function formatOrderType(orderType: OrderType) {
  if (orderType === `delivery`) return `Delivery`;

  if (orderType === `pickup`) return `Pickup`;

  return `Ordering`;
}

/**
 * Returns an array of hours, broken up by day.
 */
export function getAllHours(hours: Array<LocationHours>, orderType: OrderType) {
  return hours.map((day) => {
    let open = day.dineInOpen;
    let close = day.dineInOpen;

    if (orderType === `delivery`) {
      open = day.deliveryOpen;
      close = day.deliveryClose;
    }

    if (orderType === `delivery`) {
      open = day.pickupOpen;
      close = day.pickupClose;
    }

    const openTime = toCivilianTime(formatHour(open));
    const closeTime = toCivilianTime(formatHour(close));

    return { day: day.day, time: `${openTime} - ${closeTime}` };
  });
}

export function formatAllHours(hours: Array<{ day: number; time: string }>) {
  return (
    <ul
      style={{
        display: `flex`,
        flexDirection: `column`,
        margin: 0,
        padding: 0,
      }}
    >
      {hours.map(({ day, time }) => (
        <li
          key={day}
          style={{
            display: `flex`,
            margin: `0 0 0.5rem 0`,
          }}
        >
          <span style={{ minWidth: `7rem`, marginRight: `0.5rem` }}>
            {toDayOfWeek(day)}
          </span>
          <span>{time}</span>
        </li>
      ))}
    </ul>
  );
}

/**
 * Returns the hours for the current day.
 */
export function getTodaysHours(
  hours: Array<LocationHours>,
  orderType: OrderType,
  showDays = true,
) {
  const dayOfWeek = new Date().getDay();
  const hour = combineHours(hours)[orderType].find(({ days }) =>
    days.includes(dayOfWeek),
  );

  return `${showDays ? `${hour.text}: ` : ``}${hour.hours}`;
}
